//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as apis from "@/api";
import { conversion } from "@/tool";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      firstTimeShowWarning: true,
      Subsidy: 0,
      subsidyGiftId: 0,
      RebateRate: 0,
      counterTime: {
        timeId: 0, //计时器id
        totalSeconds: 0,
        day: "00",
        hour: "00",
        min: "00",
        sec: "00",
      },
    };
  },
  computed: {
    ...mapState(["user"]),
    list() {
      let arr = [];
      if (this.activetyList && this.activetyList.length > 0) {
        arr = this.activetyList;
      }
      return arr;
    },
  },
  filters: {
    conversion,
  },
  watch: {},
  created() {
    this.GetList();
    // this.getSubsidy();
    // this.getRebateDetail();
    this.sumTime(this.counterTime.totalSeconds);

    this.counterTime.timeId = setInterval(() => {
      this.sumTime();
    }, 1000);
  },
  mounted() {},
  methods: {
    loginbtnClick() {
      this.$store.commit("setloginModal", true);
    },
    GetList() {
      apis.api_GetGiftList().then((res) => {
        let filteredData = res.data.data.find((item) => item.useType === 7);
        this.subsidyGiftId = filteredData.id;
      });
    },
    getSubsidy() {
      apis.api_GetSubsidy().then((res) => {
        console.log(res);
        this.Subsidy = Math.floor(res.data.data.subsidy * 100) / 100;
      });
    },
    takeSubsidy() {
      if (this.firstTimeShowWarning) {
        this.$toast.info("每天只可领取一次，确定领取请再次点击领取");
        this.firstTimeShowWarning = false;
        return;
      }
      apis.api_ReceiveGift({ id: this.subsidyGiftId }).then((res) => {
        if (res.data.code === 0) {
          this.$toast.success(res.data.msg);
        } else {
          this.$toast.error(res.data.msg);
        }
      });
    },
    sumTime() {
      //  当前时间
      const nowtime = Date.parse(new Date());
      //  结束时间
      const end = this.endTime();
      const date = new Date(end);
      const endtime = date.getTime();

      //  倒计时时间
      var leftTime = endtime - nowtime;
      var leftsecond = parseInt(leftTime / 1000);
      var day = Math.floor(leftsecond / (60 * 60 * 24));
      var hour = Math.floor((leftsecond - day * 24 * 60 * 60) / 3600);
      var minute = Math.floor(
        (leftsecond - day * 24 * 60 * 60 - hour * 3600) / 60
      );
      var second = Math.floor(
        leftsecond - day * 24 * 60 * 60 - hour * 3600 - minute * 60
      );

      // console.log(hour,minute,second,9999999)
      // const now = new Date();
      // const dayOfWeek = now.getDay();
      // const daysUntilSunday = dayOfWeek === 0 ? 7 : 7 - dayOfWeek;
      // const nextSunday = new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysUntilSunday, 23, 59, 59);
      // const timeRemaining = nextSunday.getTime() - now.getTime();

      // const totalSeconds = Math.floor(timeRemaining / 1000);
      // const days = Math.floor(totalSeconds / (60 * 60 * 24));
      // const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
      // const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
      // const seconds = Math.floor(totalSeconds % 60);
      // //console.log(`${days}天 ${hours}時 ${minutes}分 ${seconds}秒`);

      // this.counterTime.day = `0${days}`.slice(-2);
      this.counterTime.hour = `0${hour}`.slice(-2);
      this.counterTime.min = `0${minute}`.slice(-2);
      this.counterTime.sec = `0${second}`.slice(-2);

      //console.log(this.counterTime);
    },
    // getRebateDetail() {
    //   apis.RebateDetail().then((res) => {
    //     this.counterTime.totalSeconds = res.data.data.totalSeconds;
    //     this.RebateRate = res.data.data.rate * 100;
    //   });
    //   console.log(this.counterTime.totalSeconds);
    // },

    // 封装的终点时间的函数
    endTime() {
      const myDate = new Date();
      const year = myDate.getFullYear();
      let month = myDate.getMonth() + 1;
      let date = myDate.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }

      return year + "/" + month + "/" + date + " " + "20:30";
    },
  },
  beforeDestroy() {
    clearInterval(this.counterTime.timeId);
  },
};
